// const logoSlider = new Swiper("#section-logo-slider", {
// 	loop: true,
// 	autoplay: {
// 		delay: 0,
// 	},
// 	speed: 5000,
// 	slidesPerView: 'auto',
// 	breakpoints: {
// 		576: {
// 			slidesPerView: 2.5,
// 		},
// 		992: {
// 			slidesPerView: 4,
// 		},
// 		1400: {
// 			slidesPerView: 6,
// 			spaceBetween: 0
// 		}
// 	}
// });

document.addEventListener("DOMContentLoaded", function () {
	const cards = document.querySelectorAll(".logo-slider__wrapper .features-col");
	if (!cards.length) return;
	let maxWidth = 0;

	cards.forEach(card => {
		const text = card.querySelector(".text");
		if (!text) return;
		text.style.whiteSpace = "normal";
		const width = text.offsetWidth;

		if (width > maxWidth) {
			maxWidth = width;
		}
	});
	maxWidth = maxWidth / 2 + 55;

	cards.forEach(card => {
		card.style.maxWidth = maxWidth + "px";
		card.style.width = maxWidth + "px";
	});
});